module.exports = __webpack_public_path__ + "static/media/natascha.2cba86e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wizard/contact/natascha.png
// module id = 1485
// module chunks = 0